import React from "react";
import { useFormikContext } from "formik";
import baseStyles from "../../style.module.scss";
import styles from "./style.module.scss";
import ReviewHeader from "../common/ReviewHeader";

const Processor = ({ onEdit, isOpen, onToggle }) => {
  const { values } = useFormikContext();

  const ProcessorItem = ({ logo, name }) => (
    <div className={styles.processorItem}>
      <div className={styles.processorContent}>
        <div className={styles.processorLogo}>
          <img src={logo} alt={name} />
        </div>
        <div className={styles.processorName}>{name || "-"}</div>
      </div>
    </div>
  );

  return (
    <div className={baseStyles.reviewSectionContainer}>
      <ReviewHeader title="Processor" isOpen={isOpen} onToggle={onToggle} />

      {isOpen && (
        <div className={baseStyles.reviewContent}>
          <div className={styles.processorList}>
            {values.additional_processors?.map((processor, index) => (
              <ProcessorItem
                key={index}
                logo={processor.logo}
                name={processor.name}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Processor;
